/** Nombres de presentación: nuevo (grande) y arquetipo antiguo (pequeño, referencia). */
const BY_ID = {
  1: { nombreNuevo: 'Sentido', nombreAntiguo: 'El Sabio' },
  2: { nombreNuevo: 'Vínculo', nombreAntiguo: 'La Reina' },
  3: { nombreNuevo: 'Acción', nombreAntiguo: 'La Artesana' },
  4: { nombreNuevo: 'Exploración', nombreAntiguo: 'El Aprendiz' },
};

const BY_NOMBRE = {
  sentido: 1,
  sabio: 1,
  'el sabio': 1,
  vinculo: 2,
  reina: 2,
  'la reina': 2,
  accion: 3,
  artesano: 3,
  artesana: 3,
  'la artesana': 3,
  'el artesano': 3,
  exploracion: 4,
  aprendiz: 4,
  'el aprendiz': 4,
};

const normalize = (s) =>
  (s || '')
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .trim();

/**
 * @param {{ id_creatividad?: number, nombre?: string }} creatividad
 */
export function getCreatividadLabels(creatividad) {
  if (!creatividad) {
    return { nombreNuevo: '—', nombreAntiguo: '' };
  }
  if (creatividad.nombre_display) {
    return {
      nombreNuevo: creatividad.nombre_display,
      nombreAntiguo: creatividad.nombre_legado || '',
    };
  }
  if (creatividad.id_creatividad && BY_ID[creatividad.id_creatividad]) {
    return { ...BY_ID[creatividad.id_creatividad] };
  }
  const key = normalize(creatividad.nombre);
  const id = BY_NOMBRE[key];
  if (id && BY_ID[id]) {
    return { ...BY_ID[id] };
  }
  return {
    nombreNuevo: creatividad.nombre || '—',
    nombreAntiguo: '',
  };
}

export default getCreatividadLabels;
